import React from 'react';
import { TPunishment } from '../utils/types';
import NAPageItemConfigList from './NAPageItemConfigList';

/**
 * Since most page items on the NotApprove page are independent info that are shown/hidden
 * depending on the details of the punishment specifications, we are using this config based
 * system to keep things standardized and organized. PageItemsFromConfigs obtain configs from the
 * NAPageItemConfigList. Each config involves getIsVisible() and renderComponent to determine
 * when to show/hide, and what to render depending on the punishment data
 */
const PageItemsFromConfigs = ({ punishmentData }: { punishmentData: TPunishment }): JSX.Element => {
  const componentList = NAPageItemConfigList.map(config => {
    if (config.getIsVisible(punishmentData)) {
      const displayComponent = config.renderComponent({ punishmentData });

      return (
        <div className='page-item-config-wrapper' key={config.configName}>
          <p>{displayComponent}</p>
        </div>
      );
    }
    return null;
  }).filter(Boolean);

  return <div>{componentList}</div>;
};

export default PageItemsFromConfigs;
